import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { bgGray } from 'shared/theme/colors'

import { CustomDateField } from '../Fields'
import { UpdateInsurancePeriodButton } from './InsurancePeriodButton'

const useStyles = makeStyles(() => ({
  lightGray: {
    color: '#8A8F9D',
  },
  insuranceBox: {
    padding: '15px',
    background: bgGray,
    display: 'grid',
    gap: '10px',
    gridTemplateColumns: '1fr 75px',
    alignItems: 'center',
    maxWidth: '500px',
    borderRadius: '6px',
  },
}))

export const InsurancePeriodSection = ({ record, canChangeEquipment, equipmentType }: any) => {
  const classes = useStyles()

  if (!record) {
    return null
  }

  // vin_number is required for adding/updating insurance periods
  const canUpdateInsurancePeriods = canChangeEquipment && record.vin_number

  const insurancePeriods = record.insurance_periods.map((period: any) => (
    <>
      <div>
        <CustomDateField source="date_range_start" record={period} />
        {period.date_range_end && (
          <>
            {' '}
            - <CustomDateField source="date_range_end" record={period} />
          </>
        )}
      </div>
      {canUpdateInsurancePeriods && (
        <div>
          <UpdateInsurancePeriodButton
            equipment={record}
            equipmentType={equipmentType}
            existingInsurancePeriod={period}
          />
        </div>
      )}
    </>
  ))

  return (
    <div className={classes.insuranceBox}>
      <div>
        <Typography variant="body2" component="span" className={classes.lightGray}>
          Insurance Periods
        </Typography>
      </div>
      <div>
        {canUpdateInsurancePeriods && (
          <UpdateInsurancePeriodButton equipment={record} equipmentType={equipmentType} />
        )}
      </div>
      {insurancePeriods}
    </div>
  )
}
